var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIconWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 6.50007C12.5001 10.2449 8.34585 14.1449 6.95083 15.3494C6.82087 15.4472 6.66268 15.5 6.50007 15.5C6.33747 15.5 6.17928 15.4472 6.04932 15.3494C4.6543 14.1449 0.5 10.2449 0.5 6.50007C0.5 4.90876 1.13215 3.38261 2.25738 2.25738C3.38261 1.13215 4.90876 0.5 6.50007 0.5C8.09139 0.5 9.61754 1.13215 10.7428 2.25738C11.868 3.38261 12.5001 4.90876 12.5001 6.50007Z",
    stroke: "#C5C5C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50003 8.75006C7.74268 8.75006 8.75006 7.74268 8.75006 6.50003C8.75006 5.25737 7.74268 4.25 6.50003 4.25C5.25737 4.25 4.25 5.25737 4.25 6.50003C4.25 7.74268 5.25737 8.75006 6.50003 8.75006Z",
    stroke: "#C5C5C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconWeb);
export default __webpack_public_path__ + "static/media/location-icon-web.ffa8425f7cb8ce9c0ef8b7087509474e.svg";
export { ForwardRef as ReactComponent };